import { TranslatableText } from '@dreryk/react-common';
import { Clipboard, LinkSize, StyledFlex, TestableComponentProps, TextView } from '@dreryk/react-components';

type TextViewWithClipboardProps = TestableComponentProps & {
   readonly label: TranslatableText;
   readonly value: string;
};

export const TextViewWithClipboard = (props: TextViewWithClipboardProps): JSX.Element => {
   return (
      <TextView label={props.label} testId={props.testId}>
         <StyledFlex gap={'8px'}>
            {props.value} <Clipboard value={props.value} size={LinkSize.SMALL} />
         </StyledFlex>
      </TextView>
   );
};
